import React, { FC } from 'react';
import IconHoverButton from '../IconHoverButton/IconHoverButton';
import parse from 'html-react-parser';
import { ISkill } from '../../model/Skill.model';
import { ISkillDetail } from '../../model/SkillDetail.model';
import { ISkillLevel } from '../../model/SkillLevel.model';
import { IEmployeeProgression } from '../../model/EmployeeProgression.model';
import EmployeeProgressionOptions from './EmployeeProgressionOptions';
import SkillLevelCheckboxes from './SkillLevelCheckboxes';
import { IEmployeeProgressionLevel } from '../../model/EmployeeProgressionLevel.model';

interface DesktopSkillGridProps {
    source: string,
    progression: IEmployeeProgression | undefined,
    employeeProgressionLevels: any[],
    skill: ISkill,
    skillLevels: Array<ISkillLevel>,
    isManager: boolean,
    currentUpn: string | undefined,
    borderColor?:string,
    progressionLevelAdded(progressionLevel:any): void;
    progressionLevelUpdated(progressionLevel:any): void;
    progressionLevelRemoved(progressionLevel:any): void;
    bookmarkRemoved(bookmark:IEmployeeProgression): void;
    bookmarkAdded(bookmark:IEmployeeProgression): void;
}


const DesktopSkillGrid: FC<DesktopSkillGridProps> = ({ source, progression, employeeProgressionLevels, 
    skill, skillLevels, isManager, currentUpn, borderColor, progressionLevelAdded, progressionLevelRemoved, progressionLevelUpdated,
    bookmarkRemoved, bookmarkAdded }) => {
    const HandleBookmarkClick = () => {

    }
  const HandleBookmarkRemoved = (bookmark:IEmployeeProgression) => {
    console.log('br', bookmark);
    bookmarkRemoved(bookmark);
  }

    const getSkillDetails = (skill: ISkill, level: ISkillLevel) => {
        let returnArray: Array<any> = [];
        if (Array.isArray(skill.details)) {
            skill.details.filter(x => x.skillLevelId === level.skillLevelId).map((detail: ISkillDetail) => {
                returnArray.push(<div className='m-t--75 m-b--75'>{parse((detail.skillText + "").replaceAll('<a href=', '<a target="_blank" rel="noopener noreferrer" href='))}</div>);
            });
        }
        //debugger;
        return returnArray;
    }

    return (
        <>
            <div className='core-desktop-max-width bottom'>
                <div className='bordered-cell' style={{borderColor: borderColor}}>
                    <EmployeeProgressionOptions source={source} progression={progression} skill={skill} skillLevels={skillLevels} isManager={isManager} bookmarkRemoved={HandleBookmarkRemoved} bookmarkAdded={bookmarkAdded} />
                </div>
                {skillLevels.map((level, index) => (
                    <div key={level.skillLevelId + index} className='bordered-cell' style={{borderColor: borderColor}}>
                        <div className='m-t--75'>{getSkillDetails(skill, level)}</div>
                        <SkillLevelCheckboxes
                            level={level}
                            skill={skill}
                            skillLevels={skillLevels}
                            isManager={isManager}
                            currentUpn={currentUpn}
                            employeeProgressionLevels={employeeProgressionLevels}
                            employeeProgressionLevelsLength={employeeProgressionLevels.length}
                            onMasteredAdded={progressionLevelAdded}
                            onMasteredChange={progressionLevelUpdated}
                            onMasteredRemoved={progressionLevelRemoved}
                        />
                    </div>
                ))}
            </div>
        </>
    )
}


export default DesktopSkillGrid;